module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load"
  }, [_c('span', {
    class: _vm.cls
  }, [_vm._v(_vm._s(_vm.font))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5bacfcf2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/refresh.vue
// module id = 576
// module chunks = 1